(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["havn-customer-reviews"] && !Shopify.designMode) return;
  try {
    
  const initHavnReviewForms = () => {
    document.querySelectorAll('[data-havn-review-root]').forEach((root) => {
      const form = root.querySelector('form.havn-customer-reviews__write-form');
      if (!form || form.dataset.havnReviewInit === 'true') return;
      form.dataset.havnReviewInit = 'true';
      const fieldsWrap = form.querySelector('.js-havn-review-fields');
      const successEl = form.querySelector('.js-havn-review-success');
      const successFlagKey = `havn_review_submitted_${form.id || 'default'}`;

      const showSuccess = () => {
        if (!fieldsWrap || !successEl) return;
        successEl.hidden = false;
        successEl.removeAttribute('hidden');
        successEl.style.display = 'block';
        fieldsWrap.classList.add('visually-hidden');
        fieldsWrap.style.display = 'none';
        successEl.focus();
      };

      form.addEventListener('submit', () => {
        try {
          sessionStorage.setItem(successFlagKey, '1');
        } catch (e) {}
      });

      try {
        const qs = new URLSearchParams(window.location.search);
        const fromQuery = qs.get('review_submitted') === 'sent';
        const fromStorage = sessionStorage.getItem(successFlagKey) === '1';
        if (fromQuery || fromStorage) {
          showSuccess();
          sessionStorage.removeItem(successFlagKey);
          const newUrl = window.location.pathname + window.location.hash;
          window.history.replaceState({}, '', newUrl);
        }
      } catch (e) {}

      form.addEventListener('submit', () => {
        root.querySelectorAll('input[name="havn_review_rating"]').forEach((input) => {
          input.disabled = true;
        });

        const msg = root.querySelector('[data-havn-review-message]');
        const bodyField = form.querySelector('textarea[name="message"]');
        if (!msg || !bodyField) return;

        const rating = root.querySelector('input[name="havn_review_rating"]:checked');
        const title = root.dataset.productTitle || '';
        const url = root.dataset.productUrl || '';
        const ratingLine = rating ? `${rating.value} / 5` : 'Not selected';

        bodyField.value = [
          '- Product review -',
          `Product: ${title}`,
          `Product URL: ${url}`,
          `Rating: ${ratingLine}`,
          '',
          msg.value.trim(),
        ].join('\n');
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHavnReviewForms);
  } else {
    initHavnReviewForms();
  }
  document.addEventListener('shopify:section:load', initHavnReviewForms);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
